export default {"src":"/_next/static/media/portfolio.342e4038.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};